import SearchControl from "./SearchControl";
import ViewControl from "./ViewControl";
import styles from "./trackListControls.module.scss";

interface TrackListControlsProps {
  setSearchTerm: (input: string) => void;
  setView: (input: string) => void;
}

const TrackListControls = ({
  setSearchTerm,
  setView,
}: TrackListControlsProps) => (
  <div className={styles.container}>
    <div className={styles.filterContainer}>
      <ViewControl setView={setView} />
      <SearchControl setSearchTerm={setSearchTerm} />
    </div>
  </div>
);

export default TrackListControls;
